export default "__VITE_ASSET__D1Ups5jn__"